<template>
  <v-app class="app-tabela">
    <div class="box" style="margin-top: 0px">
      <v-card class="tabela">
        <v-card-title>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Nome"
            class="input-bottom"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :key="nomeColunaAcoes"
          ref="tableAcoesInterprofissionais"
          @pagination="getPagination"
          :page="currentPage"
          :footer-props="{
            itemsPerPageText: '',
            'items-per-page-options': [10],
            'disable-items-per-page': true,
          }"
          :loading="loading"
          loading-text="Carregando, Por favor espere"
          :headers="headers"
          :items="indexedItems"
          :item-class="getRowColor"
          :search="search"
          show-expand
          :single-expand="true"
          :expanded.sync="expanded"
          item-key="id"
          class="elevation-1"
          @item-expanded="onItemExpanded"
        >
          <!-- <template #footer.prepend>
          <v-spacer />
        </template> -->
          <template v-slot:[`footer.page-text`]="items">
            <div class="info-table-item tabela-esus-pec">
              <FonteSincronizadorC />
            </div>
            <span class="paginacao"
              >{{ calculatePageSum() }} de {{ calculateTotalSum() }} ações</span
            >
          </template>

          <template v-slot:header.acoes>
            {{ nomeColunaAcoes }}
            <span
              v-b-tooltip.hover.right
              title="Atendimento individual, atividade coletiva ou compartilhamento do cuidado"
              class="icon-tooltip"
            >
              <i class="icofont-info-circle"></i>
            </span>
          </template>

          <template v-slot:item.dt_nascimento="{ item }">
            {{
              item.dt_nascimento != '-' ? formatDate(item.dt_nascimento) : '-'
            }}
          </template>

          <template v-slot:item.acoes="{ item }">
            {{ quantidadeAcoes(item) }}
          </template>

          <template v-slot:expanded-item="{ headers, item }">
            <td colspan="9">
              <table class="table table-interna">
                <thead>
                  <tr>
                    <th>Data</th>
                    <th>Tipo</th>
                    <th>Equipe</th>
                    <th>Profissional</th>
                    <th>NM</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item2, index) in item.dadosFormatado"
                    :key="index"
                  >
                    <td>
                      {{
                        item2.dt_acao != null ? formatDate(item2.dt_acao) : ''
                      }}
                    </td>
                    <td>
                      {{ item2.tp_acao }}
                    </td>
                    <td>
                      {{ item2.nu_ine }}
                      <span
                        v-if="item2.no_equipe != null"
                        v-b-tooltip.hover.right
                        :title="item2.no_equipe"
                        class="icon-tooltip"
                      >
                        <i class="icofont-info-circle"></i>
                      </span>
                    </td>
                    <td>{{ item2.no_profissional }}</td>
                    <td>{{ item2.nm != 0 ? 'Sim' : '' }}</td>
                  </tr>
                </tbody>
              </table>
            </td>
          </template>
          <template v-slot:progress>
            <v-progress-linear
              color="blue"
              :height="10"
              indeterminate
            ></v-progress-linear>
          </template>
          <template v-slot:no-data>
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
          <template v-slot:no-results style="padding: 0px">
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </v-app>
</template>

<script>
import Vue from 'vue'
import * as Functions from '../functions.js'
import utils from '@/mixins/utils.js'
import ShowHideField from '@/components/utils/ShowHideField.vue'
import Copilot from '@/components/Copilot.vue'
import { rulesCopilot } from '../copilot.js'

export default {
  name: 'TabelaCadastros',
  components: {
    ShowHideField,
    Copilot,
  },
  props: {
    cadastros: {
      type: Array,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
    mes: {
      type: [Object, String, Number],
      default: null,
    },
    equipe: {
      type: [Object, String],
      default: null,
    },
    tipoAcao: {
      type: String,
      default: 'todas',
    },
  },
  mixins: [utils],
  data() {
    return {
      currentPage: 1,
      expanded: [],
      enabled: null,
      search: '',
      modal: {
        show: false,
        item: null,
      },
    }
  },
  watch: {
    cadastros: {
      handler(newValue, oldValue) {
        this.currentPage = 1
      },
      deep: true,
    },
    search: {
      handler(newValue) {
        if (newValue) {
          this.$emit('filterSearch', { filter: this.filterItems(newValue) })
          return
        }
        this.$emit('filterSearch', { filter: false })
      },
      deep: true,
    },
  },
  computed: {
    exibirCopilot() {
      if (this.$store.state.infoMunicipio?.exibe_whatsapp == '1') {
        return true
      }
      return false
    },
    nomeColunaAcoes() {
      return Functions.getNomeColunaAcoes(this.tipoAcao)
    },
    headers() {
      return [
        {
          text: 'Nome',
          align: 'start',
          filterable: true,
          value: 'no_cidadao',
        },
        {
          text: 'Nascimento',
          align: 'start',
          filterable: false,
          value: 'dt_nascimento',
        },
        {
          text: 'Mãe',
          align: 'start',
          filterable: false,
          value: 'no_mae',
        },
        {
          text: this.nomeColunaAcoes,
          align: 'start',
          filterable: false,
          value: 'acoes',
        },
        { text: '', value: 'data-table-expand' },
      ]
    },
    indexedItems() {
      if (this.cadastros !== undefined) {
        return this.cadastros.map((item, index) => {
          let dados = []

          try {
            dados =
              typeof item.dados === 'string'
                ? JSON.parse(item.dados)
                : item.dados || []
          } catch (error) {
            console.error('Erro ao fazer parse do campo dados:', error)
            dados = []
          }

          return {
            id: index,
            dadosFormatado: dados,
            ...item,
            no_cidadao: item.no_cidadao ?? '-',
            no_mae: item.no_mae ?? '-',
            dt_nascimento: item.dt_nascimento ?? '-',
          }
        })
      }

      return []
    },
  },
  methods: {
    /**
     * Retorna os itens filtrados internamente pelo v-data-table.
     *
     * @returns {Array}
     */
    getFilteredTableItems() {
      return (
        this.$refs.tableAcoesInterprofissionais?.$children[0]?.filteredItems ||
        []
      )
    },

    /**
     * Retorna os itens considerados no cálculo.
     *
     * Se houver busca ativa, usa os itens filtrados pelo v-data-table.
     * Caso contrário, usa todos os itens indexados.
     *
     * @returns {Array}
     */
    getItemsForSum() {
      if (this.search !== '') {
        return this.getFilteredTableItems()
      }

      return this.indexedItems || []
    },

    /**
     * Calcula a quantidade de agendados da página atual.
     *
     * @returns {Number}
     */
    calculatePageSum() {
      const startIndex = (this.currentPage - 1) * 10
      const endIndex = startIndex + 10

      const pageItems = this.getItemsForSum().slice(startIndex, endIndex)

      return pageItems.reduce((sum, item) => {
        return sum + Number(this.quantidadeAcoes(item) || 0)
      }, 0)
    },

    /**
     * Calcula a quantidade total de agendados de todas as páginas.
     *
     * @returns {Number}
     */
    calculateTotalSum() {
      return this.getItemsForSum().reduce((sum, item) => {
        return sum + Number(this.quantidadeAcoes(item) || 0)
      }, 0)
    },

    /**
     * Retorna a quantidade de agendados exibida na tabela.
     *
     * Se houver mês selecionado, retorna apenas as agendados do mês.
     * Caso contrário, retorna todas as agendados encontradas nos procedimentos.
     *
     * @param {Object} item
     * @returns {Number}
     */
    quantidadeAcoes(item) {
      return Functions.getQuantidadeAcoes(
        item,
        this.mes,
        this.tipoAcao,
        this.equipe
      )
    },

    /**
     * Filtra os registros da tabela com base no texto de busca.
     * Considera apenas as colunas marcadas como filtráveis nos headers.
     * @param {String} search Texto digitado para pesquisa
     * @returns {Array} Lista de itens filtrados
     */
    filterItems(search) {
      const searchTerms = search.toLowerCase().trim()
      const filteredItems = this.cadastros.filter((item) => {
        for (const header of this.headers) {
          if (header.filterable && item.hasOwnProperty(header.value)) {
            const itemValue = String(item[header.value]).toLowerCase()
            if (itemValue.includes(searchTerms)) {
              return true
            }
          }
        }
        return false
      })
      return filteredItems
    },

    /**
     * Atualiza a página atual da tabela.
     * @param {Object} options Dados da paginação
     */
    getPagination(options) {
      this.currentPage = options.page
    },

    /**
     * Retorna a classe CSS da linha da tabela.
     *
     * @param {Object} item
     * @returns {String}
     */
    getRowColor(item) {
      if (item.num_acoes_inter_prof > 0) {
        return `table-row-color-green`
      }
      return `table-row-color-orange`
    },

    /**
     * Manipula o evento de expansão de um item da tabela.
     * @param {Object} item Contexto do item expandido
     */
    async onItemExpanded(item) {
      try {
        const rules = await rulesCopilot(item.item)
        Vue.set(item.item, 'rules', rules)
      } catch (error) {
        console.error('Erro ao obter as regras:', error)
      }
    },

    /**
     * Abre o modal
     * @param {Object} item
     */
    openModalAtendimento(item) {
      this.modal.show = true
      this.modal.item = item
    },
  },
}
</script>

<style>
.tabela .green-color {
  color: green !important;
}
.tabela .red-color {
  color: red !important;
}
</style>
<style scoped lang="scss">
.ultimo-acompanhamento {
  display: flex;
  align-items: center;
  // flex-direction: column;
  gap: 10px;
  span {
    background: #c4e8f6;
    color: #00aeef;
    padding: 5px 10px;
    border-radius: 10px;
    font-size: 11px;
  }
}

.icon-copilot {
  img {
    background: #f7f7f7;
    color: #00aeef;
    border-radius: 10px;
    text-align: center;
    width: 40px;
    padding: 10px;
  }
}

.container-table-interna {
  height: 300px;
  overflow-y: scroll;
}
</style>
